import ExchangeBalance from './ExchangeBalance';

export default ExchangeBalance;
